export { default } from "./BetaBadgeView";
export type { BetaBadgeViewProps } from "./BetaBadgeView";
